export default {
  startNew: 'Neue Parser-Datei erstellen',
  section: 'Parser Bereich',
  required: 'Füllen Sie die erforderlichen * Feldkonfigurationen unten aus.',
  code_comment: 'Hier erscheinst eine Voransicht des generierten Parser Codes'
}